import React from "react";


import PrivateComponent from 'auth/PrivateComponent.js'

import Logo from './logo.png';
import LogoFooter from './logo.png';

import {  CssBaseline,
          Divider,
          IconButton,
          // List, ListItem, 
          ListItemIcon, ListItemText, ListItemButton,
          Container,
          Box,
          Toolbar,
          Typography,
          Collapse,
          MenuList, MenuItem,
          

        } from '@mui/material'



import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';

import MenuIcon from '@mui/icons-material/Menu';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PersonIcon from '@mui/icons-material/Person';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BuildIcon from '@mui/icons-material/Build';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import RoofingIcon from '@mui/icons-material/Roofing';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';

import {  withStyles,
          useTheme
       } from "@mui/styles";

import { styled } from '@mui/material/styles';

import { Link, withRouter} from 'react-router-dom'

// import withRouter  from 'adds/router/withRouter.js';

import { authenticationService } from 'auth/authenticationService'


const drawerWidth = 270;


const use_styles = {
  root: {
    display: 'flex',
  },
  logo: {
    height: 40,
    paddingRight: 50
  },
  logo_footer: {
    height: 30,
    paddingRight: 0
  },
  nested: {
  },
};

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);



class Layout extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      window: props.window,
      mobileOpen: false,
      open:true,
      container: props.window !== undefined ? () => window().document.body : undefined,
      basket: false,
      width:0,
      height:0,
      unlisten: false,
      menu:{
        permisos:null,
        obras:null,
      },
      cart_status:0,
      // theme: useTheme()
    };

    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleDropdown = this.handleDropdown.bind(this);
    // console.log(this.props)

    
  }

  handleDrawerOpen(){
    this.setState({open:true});
  };
  handleDrawerClose(){
    this.setState({open:false});
  };
  handleDropdown(witch){
    let menu = this.state.menu
    menu[witch] = !menu[witch]
    this.setState({menu:menu});
  };
  handleLogout(){
    authenticationService.logout();
    this.props.history.push('/login');

  }
  updateDimensions = () => {
    if(window.innerWidth<1000){
      this.setState({open:false});
    }
    else{
      this.setState({open:true});
    }
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };
  componentDidMount(){
    // let groups = authenticationService.currentUser.groups;
    // console.log(this.props)

    window.addEventListener('resize', this.updateDimensions);

    // this.unlisten = this.props.history.listen((location, action) => {
    //   this.updateDimensions();
    // });
    this.updateDimensions();


    let path = this.props.location.pathname;

    if (path.indexOf('/permisos') === 0) {
      this.setState(prevState => ({
        menu: {
          ...prevState.menu,
          permisos: true,
        }
      }));
    }
    if (path.indexOf('/obras') === 0) {
      this.setState(prevState => ({
        menu: {
          ...prevState.menu,
          obras: true,
        }
      }));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    // this.unlisten();
  }

  render(){
  const { location: { pathname } } = this.props;
  
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={this.state.open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={this.handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: '36px',
              ...(this.state.open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            {this.props.title}
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={this.state.open}>
        <DrawerHeader>
          <img src={Logo} alt='logo' className={this.props.classes.logo}/>
          <IconButton onClick={this.handleDrawerClose}>
            {/* {this.props.theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />} */}
            <ChevronRightIcon />
          </IconButton>
        </DrawerHeader>
        <Divider />

        <PrivateComponent group={['employee',]}>
          <MenuList dense>
            <MenuItem  key='Dashboard' component={Link} to='/dashboard/'>

              <ListItemIcon><DashboardIcon color='inherit' fontSize="small"/></ListItemIcon>
              <ListItemText primary='Inicio Funcionario' />
            </MenuItem>
            <MenuItem  key='permiso_circulacion' component={Link} to="/permiso_circulacion/" selected={pathname === '"/permiso_circulacion/"'}>
              <ListItemIcon><PersonIcon color='inherit' /></ListItemIcon>
              <ListItemText primary='Permisos de Circulación' />
            </MenuItem>
          </MenuList>
        </PrivateComponent>

        
        <MenuList>
          {/* <PrivateComponent roles={['permisos',]}> */}
            <MenuItem  onClick={() => this.handleDropdown('permisos')}>
              <ListItemIcon>
                <DirectionsCarIcon fontSize="small"/>
              </ListItemIcon>
              <ListItemText sx={{ pl: 0.4 }} primary="Permisos de circulación" />
              {this.state.menu.permisos ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>            
            <Collapse in={this.state.menu.permisos} timeout="auto" unmountOnExit className={this.props.classes.nested} >
              <MenuList>
                <MenuItem sx={{ pl: 3 }} key='Dashboard' component={Link} to='/dashboard/'  selected={pathname === '/permisos/dashboard/'}>
                  <ListItemIcon><DashboardIcon/></ListItemIcon>
                  <ListItemText sx={{ pl: 0.4 }} primary='Bandeja de entrada' />
                </MenuItem>
                <MenuItem sx={{ pl: 3 }} key='Estadisticas' component={Link} to='/permisos/estadisticas/'  selected={pathname === '/permisos/estadisticas/'}>
                  <ListItemIcon><EqualizerIcon/></ListItemIcon>
                  <ListItemText sx={{ pl: 0.4 }} primary='Estadisticas' />
                </MenuItem>

                <MenuItem sx={{ pl: 3 }} component={Link} to='/permisos/vehiculo/' selected={pathname === '/permisos/vehiculo/'}>
                  <ListItemIcon><QrCodeIcon fontSize="small"/></ListItemIcon>
                  <ListItemText primary="Registro Vehículos" />
                </MenuItem>
                <MenuItem sx={{ pl: 3 }} component={Link} to='/permisos/lista/' selected={pathname === '/permisos/lista/'}>
                  <ListItemIcon><ListAltIcon  fontSize="small"/></ListItemIcon>
                  <ListItemText primary="Listas Empresas" />
                </MenuItem>
                <MenuItem sx={{ pl: 3 }} key='EstadoServicios' component={Link} to='/permisos/estado_servicios/'  selected={pathname === '/permisos/estado_servicios/'}>
                  <ListItemIcon><NetworkCheckIcon/></ListItemIcon>
                  <ListItemText sx={{ pl: 0.4 }} primary='Estado servicios' />
                </MenuItem>
                <PrivateComponent roles={['super_admin',]}>
                  <MenuItem sx={{ pl: 3 }} key='Administracion' component={Link} to='/permisos/administracion/'  selected={pathname === '/permisos/administracion/'}>
                    <ListItemIcon><BuildIcon/></ListItemIcon>
                    <ListItemText sx={{ pl: 0.4 }} primary='Administración' />
                  </MenuItem>
                </PrivateComponent>
              </MenuList>
            </Collapse>
          {/* </PrivateComponent> */}
          <PrivateComponent roles={['obras',]}>
            <MenuItem  onClick={() => this.handleDropdown('obras')}>
              <ListItemIcon>
                <RoofingIcon fontSize="small"/>
              </ListItemIcon>
              <ListItemText sx={{ pl: 0.4 }} primary="Dirección de Obras" />
              {this.state.menu.obras ? <ExpandLess /> : <ExpandMore />}
              
            </MenuItem>
            <Collapse in={this.state.menu.obras} timeout="auto" unmountOnExit className={this.props.classes.nested} >
              <MenuList>
                <MenuItem sx={{ pl: 3 }} key='Predios' component={Link} to='/obras/predios/'  selected={pathname === '/obras/predios/'}>
                  <ListItemIcon><WallpaperIcon/></ListItemIcon>
                  <ListItemText sx={{ pl: 0.4 }} primary='Predios' />
                </MenuItem>
                <MenuItem sx={{ pl: 3 }} key='Certificados' component={Link} to='/obras/certificados/'  selected={pathname === '/obras/certificados/'}>
                  <ListItemIcon><FileCopyIcon/></ListItemIcon>
                  <ListItemText sx={{ pl: 0.4 }} primary='Certificados' />
                </MenuItem>
              </MenuList>
            </Collapse>

          </PrivateComponent>
        </MenuList>

        <Divider />
        <MenuList>

          
          <MenuItem  key='exit' onClick={this.handleLogout}>
              <ListItemIcon><ExitToAppIcon color='inherit' /></ListItemIcon>
              <ListItemText sx={{ pl: 0.4 }} primary='Cerrar sesión' />
          </MenuItem>
        </MenuList>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
        <DrawerHeader />
        <Container maxWidth="lg">
          {this.props.children}
        </Container>
        <Container>
          <Box p={1}>
            <Typography variant='h6' color='textSecondary'>
              <img src={LogoFooter} alt='Logo' className={this.props.classes.logo_footer}/> 
              &nbsp;&nbsp;- - - - Portal interno
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
    );
  }
}



export default withRouter(withStyles(use_styles, { withTheme: true })(Layout));
